<template>
    <div class="page">
        <div class="main_body">
            <div class="top_label">
                <span class="lable_name">分层教学</span>

            </div>
            <el-input v-model="keyword" :clearable="true" @input="changKeyword" style="margin-top:20px" placeholder="请输入班级名称"></el-input>

        

            <div class="stage_plan">
                <div v-for="(item,index) in plan_data" :key="index" class="stage_plan_item">
                    <div class="stage_plan_name">
                        <span class="name_text">{{item.plan_name}}</span>
                        <el-tag size="small">{{item.level_name}}层</el-tag>
                    </div>
                    <div class="stage_plan_tag">
                        <div class="tag_item">
                            <div class="tag_item_numberbox">
                                <span class="number">{{item.total_student_count}}</span>
                                <span class="unit">人</span>
                            </div>
                            
                            <span class="text">班级人数</span>
                        </div>
                        <div style="color:#F56C6C" class="tag_item">
                            <div class="tag_item_numberbox">
                                <span style="color:#F56C6C" class="number">{{item.not_qualified_count}}</span>
                                <span class="unit">人</span>
                            </div>
                            <span class="text">未达标</span>
                        </div>
                        <div class="tag_item">
                            <div class="tag_item_numberbox">
                                <span class="number">{{item.not_done_count}}</span>
                                <span class="unit">人</span>
                            </div>
                            <span class="text">未做题</span>
                        </div>
                        <div class="tag_item">
                            <div class="tag_item_numberbox">
                                <span class="number">{{item.avg_score}}</span>
                                <span class="unit">%</span>
                            </div>
                            <span class="text">平均正确率</span>
                        </div>
                        <div class="tag_item">
                            <div class="tag_item_numberbox">
                                <span class="number">{{item.avg_integral}}</span>
                                <span class="unit">分</span>
                            </div>
                            <span class="text">平均积分</span>
                        </div>
                    </div>
                    <div class="stag_info">
                        <span>{{item.stage_desc}}</span>
                        <span>未达到要求不能参加考试</span>
                    </div>
                    <div class="stag_plan_button">
                        <el-button @click="$router.push({name:'Stage',query:{plan_id:item.plan_id,level:item.level_name,trem:item.trem,plan_name:item.plan_name}})"  type="primary" size="small" class="el-icon-edit"> 查看学习情况</el-button>
                    </div>
                </div>
            </div>
            <el-empty v-if="!plan_data.length" description="暂无信息"></el-empty>
            <div class="stage_plan_pagition">
    
                <el-pagination background layout="prev, pager, next" :total="total_number" :page-size="form_data.pageSize" :current-page="form_data.page" @current-change="changeNumber" />
            </div>    
            
            
        </div>
    </div>
</template>
<script>
import Http from "../../apis/teach";
import Stagehomechart from "../../../untils/chart/stagehomechart.vue";
export default {
    components:{
        Stagehomechart
    },
    data(){
        return{
            loading:true,
            keyword:'',
            total_number:0,
            plan_data:[],
            form_data:{
                page:1,
                pageSize:9,
                keyword :''
            },
        }
    },

    created(){
        this.getList()
    },


    methods:{
        // 获取班级列表
        // state 0 管理中的班级码历史班级
        getList(){
            const loading = this.$loading({
                lock: true,
                text: '疯狂加载中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            Http.getStagePlan(this.form_data).then((res) => {
                this.plan_data = res.data.list
                this.total_number = res.data.total
                loading.close()
            });
        },

        // 点击页码
        changeNumber(e){
            this.form_data.page = e
            this.getList()
        },

        // 搜索班级
        changKeyword(value){
            this.form_data.keyword = value
            this.getList();
        },

        Statisticsdetail(plan_id){
            var _this = this
            _this.$router.push({name:'Stage',query:{plan_id:plan_id}});
        }
    }
}
</script>
<style scoped>

.top_label{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
}
.stage_plan{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 20px;
}
.stage_plan_item{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    box-sizing: border-box;
}
.stage_plan_name{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.name_text{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}
.stage_plan_tag{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    margin-top: 20px;
}
.tag_item{
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    background: #ECF5FF;
    padding: 10px 7px;
    box-sizing: border-box;
    border-radius: 5px;
}
.tag_item .number{
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}
.tag_item .text{
    font-size: 12px;
    opacity: 0.8;
}
.tag_item .unit{
    font-size: 12px;
    opacity: 0.8;
}
.tag_item_numberbox{
    display: flex;
    align-items: center;
    gap: 4px;
}
.stag_info{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    font-size: 14px;
    opacity: 0.8;
    background: #ECF5FF;
    padding: 10px;
    border-radius: 5px;
    margin-top: 15px;
}
.stag_plan_button{
    margin-top: 15px;
}

.stage_plan_pagition{
    margin-top: 25px;
    margin-bottom: 20px;
}











.list_thumb{
    float: left;
    width: 165px;
    height: 110px;
}

.list_thumb img{
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.list_info{
    height: 110px;
    float: left;
    box-sizing: border-box;
    padding-left: 15px;
}
.list_info_text{
    width: 100%;
    text-align: left;
    display: inline-block;
    margin-bottom: 10px;
}

.list_info_text span{
    display: inline-block;
    margin-right: 5px;
    
}
.list_right{
    float: right;
    width: 10vw;
    height: 5.5vw;
    line-height: 5.5vw;
}

.main_body >>> .el-card__body{
    float: left;
    width: 100%;
    padding-right: 25px;
    box-sizing: border-box;
}
.main_body >>> .el-col{
    margin-bottom: 20px;
}
.label_button_box{
    width: 100%;
    height: 2vw;
    line-height: 2vw;
    display: inline-block;
    margin-bottom: 20px;
    margin-top:10px;
}
.label_button_box_left{
    float: left;
}
.label_button_box_right{
    float: left;

}
.label_button_box_right >>> .el-input{
    float: left;
    width: 15vw;
}
.label_button_box >>> .el-checkbox{

    float: left;
    margin-right: 20px;
}
._list >>>.el-checkbox{
    
    margin-top: 2.2vw;
}
.list_thumb{
    position: relative;
}
.plan_tage{
    position: absolute;
    width: 60px !important;
    height: 38px !important;
    left: 0;
}
.stage_home_chart{

    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    box-sizing: border-box;
    margin-top: 20px;
}
</style>